import StoriesTemplate from './stories.html';

export default angular
  .module('main.devices.edit.tabs.stories', [])

  .directive('editDeviceStoriesTab', () => {
    return {
      restrict: 'E',
      template: StoriesTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        angular.extend($scope, {});

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceLocationOrganizationBrandResource.init()
          ])
            .then(() => {
              $scope.loading = false;
              $scope.deviceModelId = $scope.dataProvider.deviceResource.value.modelId;
              $scope.brand = $scope.dataProvider.deviceLocationOrganizationBrandResource.value;
            }, () => {
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
